// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".project-selector {\n  width: 600px;\n  position: relative !important;\n  background-color: var(--v-white-base);\n  border-radius: var(--brand-surface-radius, 4px) !important;\n}\n.project-selector button.v-btn.close-dialog {\n  position: absolute;\n  right: 4px !important;\n  top: 6px !important;\n}", ""]);
// Exports
module.exports = exports;
